import { render, staticRenderFns } from "./AppStatisticsManager.vue?vue&type=template&id=bb85d388&scoped=true"
import script from "./AppStatisticsManager.vue?vue&type=script&lang=js"
export * from "./AppStatisticsManager.vue?vue&type=script&lang=js"
import style0 from "./AppStatisticsManager.vue?vue&type=style&index=0&id=bb85d388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb85d388",
  null
  
)

export default component.exports